import { useState, useMemo } from "react";
import { fmtEur } from "@/lib/quote";

export const MenuBuilder = ({ q, save, catalog }) => {
  const [showMenu, setShowMenu] = useState(false);

  const counts = useMemo(
    () => ({ adulti: q.guests.adults, ragazzi: q.guests.teens || 0, bambini: q.guests.children }),
    [q.guests]
  );
  const budgetTarget = useMemo(
    () => Object.entries((q.food?.groups) || {}).reduce((s, [g, c]) => s + (Number(c?.budget_pp) || 0) * (counts[g] || 0), 0),
    [q.food, counts]
  );
  const dishesTotal = useMemo(
    () => q.items.filter((i) => i.category === "Food" && !["food-", "torta-"].some((p) => String(i.product_id).startsWith(p))).reduce((s, i) => s + i.price * i.qty * (1 - (i.discount || 0) / 100), 0),
    [q.items]
  );
  const dishes = useMemo(() => catalog.filter((p) => p.category === "Food" && p.active), [catalog]);
  const dishGroups = useMemo(() => [...new Set(dishes.map((p) => p.menuGroup))], [dishes]);
  const guestsTot = counts.adulti + counts.ragazzi + counts.bambini;

  const addDish = (p) =>
    save({ items: [...q.items, { product_id: p.id, name: p.name, category: "Food", price: p.price, vat: p.vat, unit: p.unit, qty: p.unit === "persona" ? guestsTot : 1, discount: 0 }] });

  return (
    <div>
      <h3 className="text-xs font-bold uppercase tracking-widest text-[#C85A32] mb-2">Componi menù Food</h3>
      <div className="bg-[#1E293B] rounded-lg p-3 space-y-2">
        <div className="text-sm flex flex-wrap gap-x-4 gap-y-1">
          <span>Budget cliente: <b className="text-[#F0B429]">{fmtEur(budgetTarget)}</b></span>
          <span data-testid="menu-dishes-total">Piatti inseriti: <b className={dishesTotal > budgetTarget && budgetTarget > 0 ? "text-rose-400" : "text-emerald-400"}>{fmtEur(dishesTotal)}</b></span>
        </div>
        <button data-testid="toggle-menu-builder" onClick={() => setShowMenu(!showMenu)} className="text-xs text-[#F0B429] hover:underline">
          {showMenu ? "Chiudi listino piatti ▲" : "Apri listino piatti per comporre il menù ▼"}
        </button>
        <div className="text-[10px] text-slate-500">I piatti proposti si caricano e modificano dal tab <b>Listino → categoria Food</b>. I piatti aggiunti compaiono tra le <b>Voci preventivo</b> qui sopra, dove puoi modificarne quantità/prezzo o eliminarli.</div>
        {showMenu && dishGroups.map((mg) => (
          <div key={mg}>
            <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-1">{mg}</div>
            <div className="flex flex-wrap gap-1.5 mt-1">
              {dishes.filter((p) => p.menuGroup === mg).map((p) => (
                <button key={p.id} data-testid={`add-dish-${p.id}`} onClick={() => addDish(p)}
                  className="text-xs px-2.5 py-1 rounded-full border border-slate-600 hover:border-[#C85A32] hover:text-[#F0B429]">
                  + {p.name} · {fmtEur(p.price)}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
